import { motion } from "framer-motion";
import { MapPin, Certificate, UsersThree } from "@phosphor-icons/react";
import { useSiteContent } from "../../contexts/SiteContentContext";
import { DEFAULT_SITE_CONTENT } from "../../lib/siteContentDefaults";

export default function Hero() {
  const c = { ...DEFAULT_SITE_CONTENT, ...useSiteContent() };
  return (
    <section id="top" className="relative min-h-[100vh] flex items-end lg:items-center pt-32 pb-16 lg:pb-0 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/35540076/pexels-photo-35540076.jpeg"
          alt="Coach Conde training a client in a Bay Area gym"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-black/20 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full grid lg:grid-cols-[1.3fr_0.7fr] gap-10 items-end">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <div className="flex flex-wrap items-center gap-3 mb-6">
            <span data-testid="hero-tag-experience" className="flex items-center gap-1.5 border border-[#D4AF37]/40 text-[#D4AF37] text-xs uppercase tracking-[0.15em] px-3 py-1.5 rounded-full">
              <Certificate size={14} weight="duotone" /> {c.hero_tag_experience}
            </span>
            <span data-testid="hero-tag-location" className="flex items-center gap-1.5 border border-white/20 text-white text-xs uppercase tracking-[0.15em] px-3 py-1.5 rounded-full">
              <MapPin size={14} weight="duotone" /> {c.hero_tag_location}
            </span>
          </div>
          <h1 data-testid="hero-headline" className="font-heading uppercase leading-none tracking-tight text-white text-5xl sm:text-6xl md:text-7xl mb-6">
            {c.hero_headline_line1}<br /> {c.hero_headline_line2} <span className="text-[#D4AF37]">.</span>
          </h1>
          <p data-testid="hero-subheadline" className="text-lg text-[#D4D4D8] max-w-xl mb-6 leading-relaxed">
            {c.hero_subheadline}
          </p>
          <div data-testid="hero-stats-row" className="flex flex-wrap items-center gap-x-5 gap-y-2 mb-8 text-sm">
            <span className="flex items-center gap-1.5 font-semibold text-white">
              <UsersThree size={16} weight="fill" className="text-[#D4AF37]" /> {c.hero_stat_lives}
            </span>
            <span className="w-1 h-1 rounded-full bg-[#52525B] hidden sm:block" />
            <span className="flex items-center gap-1.5 font-semibold text-white">
              <Certificate size={16} weight="fill" className="text-[#D4AF37]" /> {c.hero_stat_years_label}
            </span>
            <span className="w-1 h-1 rounded-full bg-[#52525B] hidden sm:block" />
            <span className="flex items-center gap-1.5 font-semibold text-white">
              5.0 <span className="text-[#D4AF37] tracking-tighter">&#9733;&#9733;&#9733;&#9733;&#9733;</span> {c.hero_stat_rating_label}
            </span>
          </div>
          <div className="flex flex-wrap gap-4">
            <a
              href="#contact"
              data-testid="hero-book-call-button"
              className="bg-[#D4AF37] text-black font-semibold tracking-wide px-8 py-4 rounded-full hover:bg-white transition-colors duration-300"
            >
              Book Free Call
            </a>
            <a
              href="#quiz"
              data-testid="hero-take-quiz-button"
              className="border border-white/30 text-white font-semibold tracking-wide px-8 py-4 rounded-full hover:bg-white/10 transition-colors duration-300"
            >
              Find Your Fitness Path
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="hidden lg:block bg-black/60 backdrop-blur-xl border border-white/10 rounded-2xl p-5"
        >
          <img
            src="https://customer-assets-0z36b82j.emergentagent.net/job_existfit-portal/artifacts/gmi6dgr4_Felix_conde.webp"
            alt="Coach Conde"
            className="w-full h-56 object-cover rounded-xl mb-4"
          />
          <p className="font-heading text-xl text-white tracking-tight">Coach Conde</p>
          <p className="text-sm text-[#A1A1AA]">Founder, Exist Fit &mdash; Bay Area</p>
        </motion.div>
      </div>
    </section>
  );
}
